export function formatNumberWithThousandSeparator(input: string | number, currencyCode?: string): string {
    if (!input) {
        return "something is wrong";
    }
    // Check if the input is a valid number
    // @ts-ignore
    if (!/^[-+]?\d*\.?\d+(?:[Ee][-+]?\d+)?$/.test(input)) {
        throw new Error("Invalid input: Not a number");
    }

    // Convert the input string to a number and format it using the currency's
    // decimal precision (zero-decimal currencies show no cents); defaults to 2.
    const num = Number(input);
    const fractionDigits = getCurrencyFractionDigits(currencyCode);
    return num.toLocaleString('en-US', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
}

// Currencies displayed as whole numbers (no minor unit) per bank business rules.
const ZERO_DECIMAL_CURRENCIES = new Set(["JPY", "KHR", "IDR", "VND"]);

function getCurrencyFractionDigits(currencyCode?: string): number {
    if (currencyCode && ZERO_DECIMAL_CURRENCIES.has(currencyCode.toUpperCase())) {
        return 0;
    }
    return 2;
}
